import angular from "angular";
import uiRouter from "angular-ui-router";
import "ngstorage";
import auth from "../../services/auth.js";
import security from "../../services/security.js";
import events from "../../services/events.js";
import env from "../../services/env.js";
import IterableService from "../../services/iterable.js";

class JobdetailssignupController {
  constructor(
    $http,
    $localStorage,
    $location,
    $state,
    AuthService,
    $rootScope,
    $scope,
    SecurityService,
    EventsService,
    EnvService,
    $timeout,
    TrackingService,
    JobService,
    CompaniesService,
    IterableService
  ) {
    this.name = "jobdetailssignup";
    this.$http = $http;
    this.$localStorage = $localStorage;
    this.$state = $state;
    this.$auth = AuthService;
    this.$rootScope = $rootScope;
    this.$location = $location;
    this.$security = SecurityService;
    this.$events = EventsService;
    this.$iterable = IterableService;
    this.$jobs = JobService;
    this.$companies = CompaniesService;
    this.$scope = $scope;
    this.$env = EnvService;
    this.jobs = [];
    this.looking_for_more = false;
    this.$timeout = $timeout;
    this.distance_to_scroll = 0.2;
    this.$tracking = TrackingService;
    this.currentUser = this.$auth.getUserData();
    this.loading_initial_jobs = true;
    this.remain_loading_count = 0;
    this.ad_origin = this.$location.$$search.src;

    this.user = {
      first_name: null,
      last_name: null,
      email: null,
      password: null,
      phone: null,
    };

    var _this = this;

    _this.SetJobForQuickSignUpListener = _this.$rootScope.$on("SetJobForQuickSignUp", function ($event, params) {
      console.log("SetJobForQuickSignUpListener");
      console.dir(params);
      _this.jobble = params;
    });

    _this.$scope.$on("$destroy", _this.SetJobForQuickSignUpListener);
  }

  sign_up() {
    var _this = this;
    console.log("sign up");
    console.dir(_this.user);
    _this.setLoader();
    _this.$auth.job_details_register(_this.user).then(
      function (response) {
        console.log("response from registration");
        console.dir(response);
        if (response.data.status === "error") {
          _this.handleError(response.data.message);
          _this.unSetLoader();
          return;
        }
        if (response.status === 200) {
          _this.$timeout(function () {
            _this.login();
            _this.track_regi();
          }, 1000);
        } else {
          alert("Error1");
        }
      },
      function (error) {
        console.log("issue registering a user");
        console.dir(error);
        alert("Error2");
        _this.unSetLoader();
      }
    );
  }

  handleError(error) {
    var _this = this;
    if (error.indexOf("Duplicate entry") > -1) {
      alert("Error: This email already exists in our system.");
    } else {
      alert("Error: " + response.data.message);
    }
  }

  login() {
    var _this = this;
    console.log("logging in...");
    console.dir(_this.user);
    _this.$auth.job_details_login(_this.user).then(
      function (response) {
        console.log("response from login");
        console.dir(response);
        if (response.status === 200) {
          _this.$timeout(function () {
            _this.reload_user(response.data);
          }, 500);
        } else {
          alert("Error3");
        }
        _this.$timeout(function () {
          _this.unSetLoader();
        }, 500);
      },
      function (error) {
        alert("Error4");
        _this.$timeout(function () {
          _this.unSetLoader();
        }, 500);
      }
    );
  }

  track_regi() {
    var _this = this;
    let user = _this.user;
    user.ad_origin = null;
    if (_this.ad_origin) {
      user.ad_origin = _this.ad_origin;
    } else {
      user.ad_origin = "None";
    }
    _this.$tracking.reportQuickRegister(user);
  }
  setLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").addClass("wait");
    });
  }

  unSetLoader() {
    var _this = this;
    _this.$timeout(function () {
      $("html").removeClass("wait");
    });
  }

  reload_user(user) {
    var _this = this;
    _this.$localStorage.logged_user = user;
    _this.currentUser = user;
    let job = _this.jobble;
    let data = _this.$iterable.set_data(null, job, user, "view");
    _this.$timeout(function () {
      _this.$rootScope.$emit("SetCurrentUserToJobDetails", user);
      _this.$rootScope.$emit("SetNewUserForJobBoardHeader", {
        user: _this.currentUser,
      });
      _this.track_jobble_view(data);
    });
  }

  track_jobble_view(data) {
    var _this = this;
    _this.$iterable.track_jobble_view(data).then(
      function (response) {
        console.log("iterable response");
        console.dir(response);
      },
      function (error) {
        console.log("iterable error");
        console.dir(error);
      }
    );
  }
}

JobdetailssignupController.$inject = [
  "$http",
  "$localStorage",
  "$location",
  "$state",
  "auth",
  "$rootScope",
  "$scope",
  "security",
  "events",
  "env",
  "$timeout",
  "tracking",
  "jobs",
  "companies",
  "iterable",
];

export default JobdetailssignupController;



// WEBPACK FOOTER //
// ./client/app/common/jobdetailssignup/jobdetailssignup.controller.js